export default {
  list: [],
  mission_view: null,
  next_url: null,
  total: 0,
};
